export const selectFirmsDashboardData = (state) => state.firmsDashboard;
